import { render, staticRenderFns } from "./ResumeChartCard.vue?vue&type=template&id=0b8f1826&scoped=true&"
import script from "./ResumeChartCard.vue?vue&type=script&lang=js&"
export * from "./ResumeChartCard.vue?vue&type=script&lang=js&"
import style0 from "./ResumeChartCard.vue?vue&type=style&index=0&id=0b8f1826&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8f1826",
  null
  
)

export default component.exports